// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.post-form__section[data-v-04e5b2e2] {\n  margin-bottom: 32px;\n}\n.post-assignment__note[data-v-04e5b2e2] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
